import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class MulticolumnIcon extends UcoastEl {
    static htmlSelector = 'multicolumn-icon'
    item: HTMLElement
    constructor() {
        super()

        this.item = q.rc(this, '.multicolumn-list__item')
        this.addEventListener('click', this.onClickItem.bind(this))
        document.body.addEventListener('click', this.onClickbody.bind(this))
    }

    onClickItem(e: Event) {
        e.preventDefault()
        e.stopPropagation()
        const items = q.rl('.multicolumn-list__item', document)
        const item = this.item
        items.forEach(_item => {
            if(item == _item) item.classList.toggle('active')
            else _item.classList.remove('active')
        })
    }

    onClickbody(e: Event) {
        const target = q.rt<Event, HTMLElement>(e)
        if(target.classList.contains('multicolumn-card__icon')) return
        const items = q.rl('.multicolumn-list__item', document)
        items.forEach(_item => {
            _item.classList.remove('active')
        })
    }
}
